import React, { useEffect, useState } from "react";

import Container from "./components/chatbot/Container";
import ChatWidgetConfig from "./config/ChatWidgetConfig";
import { initExtendedApiWrapper } from "./services/api-handlers";
import "./index.css";

const Widget = (props) => {
  const [isApiInitialized, setIsApiInitialized] = useState(false);
  const finalProps = {
    ...ChatWidgetConfig, // Default config from the file
    ...(window.ChatWidgetConfig || {}), // Allow dynamic overrides from HTML
    ...props, // Props passed from mountWidget take priority
  };
  useEffect(() => {
    if (finalProps.apiUrl) {
      initExtendedApiWrapper(finalProps.apiUrl);
      setIsApiInitialized(true);
    } else {
      console.warn("API URL not provided to ChatWidget.");
    }
  }, [finalProps.apiUrl]);
  if (!isApiInitialized) return null;
  return (
    <div className="main">
      <Container {...finalProps} />
    </div>
  );
};

export default Widget;
